import { Timestamp } from 'firebase/firestore';
export const getCurrentTimeStamp = (time = 0) => Timestamp?.now().toMillis() + time;
